import {
  faFacebook,
  faInstagram,
  faPinterest,
  faXTwitter,
  faYoutube,
} from '@fortawesome/free-brands-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import IconButton from '@mui/material/IconButton';
import React from 'react';

const SocialBar = ({ data }) => {
  if (!data || !data.profile) return <></>;

  const socialProfiles = [];

  const { facebook, twitter, instagram, pinterest, youtube } = data.profile;

  if (facebook)
    socialProfiles.push({
      icon: faFacebook,
      link: 'https://facebook.com/',
      user: facebook,
      label: 'Facebook',
    });
  if (twitter)
    socialProfiles.push({
      icon: faXTwitter,
      link: 'https://twitter.com/',
      user: twitter,
      label: 'Twitter',
    });
  if (instagram)
    socialProfiles.push({
      icon: faInstagram,
      link: 'https://instagram.com/',
      user: instagram,
      label: 'Instagram',
    });
  if (youtube)
    socialProfiles.push({
      icon: faYoutube,
      link: 'https://youtube.com/channel/',
      user: youtube,
      label: 'Youtube',
    });
  if (pinterest)
    socialProfiles.push({
      icon: faPinterest,
      link: 'https://pinterest.com/',
      user: pinterest,
      label: 'Pinterest',
    });

  return (
    <div className="py-2">
      {socialProfiles.map(({ icon, link, user, label }) => {
        return (
          <a
            key={link}
            target="_blank"
            rel="noreferrer noopener"
            href={`${link}${user}`}
          >
            <IconButton aria-label={label} size="large">
              <FontAwesomeIcon
                icon={icon}
                style={{ width: '22px', height: '22px' }}
              />
            </IconButton>
          </a>
        );
      })}
    </div>
  );
};

export default SocialBar;
